export default __webpack_public_path__ + "static/media/pc-peshawar.1891931e.jpg";